import Vue from 'vue';
import values from 'lodash/values';
import keyBy from 'lodash/keyBy';
import {
    addDomain,
    deleteDomain,
    fetchDomainVerificationRecords,
    refreshVerification,
    verifyDomain,
} from './domains.utils';

let loadAllPromise;

export default {
    namespaced: true,
    state: {
        map: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setMapAtKey (state, { id, domain }) {
            Vue.set(state.map, id, domain);
        },
        deleteMapKey (state, { id }) {
            Vue.delete(state.map, id);
        },
    },
    actions: {
        async loadAll ({ commit, rootGetters }, { reFetch = false } = {}) {
            if (loadAllPromise && reFetch !== true) {
                await loadAllPromise;

                return;
            }

            try {
                const orgId = rootGetters['organization/getActive'].id;
                loadAllPromise = fetchDomainVerificationRecords(orgId);
                const domains = await loadAllPromise;
                commit('setMap', {
                    map: keyBy(domains, 'id'),
                });
            } catch (error) {
                loadAllPromise = null;
                throw error;
            }
        },
        async verifyDomain ({ getters, rootGetters }, { targetUrl } = {}) {
            const existingRecord = getters.list.find((domain) => domain.domainName === targetUrl);
            if (existingRecord?.isActive) return true;

            try {
                const orgId = rootGetters['organization/getActive'].id;
                const verified = await verifyDomain(orgId, targetUrl);

                return verified;
            } catch (error) {
                throw error;
            }
        },
        async add ({ commit, rootGetters }, { targetUrl } = {}) {
            try {
                const orgId = rootGetters['organization/getActive'].id;
                const domain = await addDomain(orgId, targetUrl);
                commit('setMapAtKey', { id: domain.id, domain });

                return domain;
            } catch (error) {
                throw error;
            }
        },
        async refresh ({ commit, rootGetters }, { domainId } = {}) {
            try {
                const orgId = rootGetters['organization/getActive'].id;
                const domain = await refreshVerification(orgId, domainId);
                commit('setMapAtKey', { id: domainId, domain });

                return domain;
            } catch (error) {
                throw error;
            }
        },
        async remove ({ commit, rootGetters }, { domainId } = {}) {
            try {
                const orgId = rootGetters['organization/getActive'].id;
                await deleteDomain(orgId, domainId);
                commit('deleteMapKey', { id: domainId });
            } catch (error) {
                throw error;
            }
        },
    },
    getters: {
        list: (state) => values(state.map),
        getById: (state) => (id) => state.map[id],
    },
};
